export default "__VITE_ASSET__By63EVMJ__"